import React from "react";
import scroll from "../../assets/img/images/scroll.gif";




const Banner = (props) => {
  return (
    <section className="banner-area banner-bg">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="banner-content text-center">
              <h2 className="title">
                Benvenuti su <span>Western Legends</span> 
                 
              </h2>
            </div>
            <div className="banner-progress-wrap">
              

              <h4 className="title">
               
              </h4>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="banner-countdown-wrap text-center">
              
            <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> 


            <img src={scroll} className="scollgif" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
